<template>
  <el-dialog title="批量撤版" :visible.sync="dialogVisible" width="80%" center>
    <div class="paper-manage">
      <list-frame class="questionnaire-list" :totalCount="totalCount" @flipPage="flipPage" :currentPage="currentPageNo" :pageSize="10">
        <template v-slot:listContent>
          <div class="paper-list-content">
            <div class="table-head">
              <div class="search">
                <div class="flex flex-between queryNameInputWrap">
                  <div>
                    <span>文章名称<span style="color:red;">*</span></span
                    >&nbsp;
                    <el-input v-model.trim="queryName" :maxlength="500" size="mini"></el-input>
                  </div>
                  <div class="head-button" @click="revokeRecord">
                    <span>撤版记录</span>
                  </div>
                </div>
                <span>报纸名称&nbsp;</span>
                <el-select size="mini" v-model="baozhiName"> <el-option v-for="(item, index) in paperList" :key="index" :label="item.name" :value="item.name"></el-option> </el-select>&nbsp;&nbsp;
                <span>报纸刊期</span>&nbsp; <el-date-picker size="mini" v-model="fromDate" type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="timestamp"> </el-date-picker>
              </div>
              <div class="btns flex flex-between">
                <div>
                  <div class="head-button" :class="{ inactive: queryName.length === 0 }" @click="getArticleList">
                    <img src="@imgs/search_mobile.png" alt="" class="input_icon input_sear" />
                    <span>查询</span>
                  </div>
                  <div class="head-button" @click="reset()" :class="{ inactive: !resetAble }">
                    <img src="@imgs/reset.png" alt="" class="input_icon input_sear" />
                    <span>重置</span>
                  </div>
                </div>
                <div class="head-button" @click="revoke" :class="{ inactive: tableData.length === 0 }">
                  <span>一键撤版</span>
                </div>
              </div>
            </div>
            <el-scrollbar style="height:calc(100vh - 500px)">
              <el-table v-loading="loading" :data="tableData" border :header-cell-style="setHeaderCellStyle" :cell-style="setCellStyle">
                <el-table-column prop="title" label="文章名称" min-width="200"> </el-table-column>
                <el-table-column prop="baoZhiName" label="报纸名称" min-width="100"> </el-table-column>
                <el-table-column prop="periodical" label="报纸刊期" min-width="100"> </el-table-column>
                <el-table-column label="操作" min-width="150">
                  <template slot-scope="scope">
                    <div class="option-button" @click="viewItem(scope.row)">查看文章</div>
                  </template>
                </el-table-column>
              </el-table>
            </el-scrollbar>
          </div>
        </template>
      </list-frame>
    </div>
  </el-dialog>
</template>
<script>
import { mapState } from 'vuex'
import ListFrame from '@components/list/listFrame'
import api from '@api/paperManager'
import compareVipRight from '@components/common/compareVipRight.js'
import moment from 'moment'
export default {
  name: 'paperArticleRevokeDialog',
  mixins: [compareVipRight],
  data() {
    return {
      totalCount: 0,
      currentPageNo: 1,
      tableData: [],
      paperList: [],
      baozhiName: '',
      queryName: '',
      fromDate: '',
      toDate: '',
      dialogVisible: false,
      loading: false,
      searchedParam: {
        baoZhiName: '',
        publishDateStart: '',
        publishDateEnd: '',
        title: ''
      },
      isInset: true //是否显示分享书刊嵌入代码
    }
  },
  components: { ListFrame },
  computed: {
    userName() {
      return localStorage.getItem('username')
    },
    resetAble() {
      return this.queryName.trim().length > 0 || this.baozhiName.length > 0 || this.fromDate || this.toDate
    }
  },

  methods: {
    revoke() {
      const param = this.searchedParam
      param.publishDate = this.searchedParam.publishDateStart
      api.revoke(param).then((res) => {
        let isSuccess = res.status === 200 && res.data.status === 0
        this.$message({
          message: res.data.message,
          type: isSuccess ? 'success' : 'error'
        })
        if (isSuccess) {
          this.getArticleList()
        }
      })
    },
    viewItem(item) {
      let path = '/digitalArticle'
      let routeUrl = this.$router.resolve({
        path: path,
        query: { id: item.id }
      })
      window.open(routeUrl.href, '_blank')
    },
    setHeaderCellStyle(options) {
      if (options.columnIndex !== 0 && options.columnIndex !== 1) {
        return { 'background-color': '#fafafa', 'text-align': 'center', color: '#333' }
      } else {
        return { 'background-color': '#fafafa', color: '#333' }
      }
    },
    setCellStyle(options) {
      if (options.columnIndex !== 0 && options.columnIndex !== 1) {
        return 'text-align: center'
      }
    },
    getManagerList() {
      const param = {
        pageNo: 1,
        pageSize: 11,
        userName: this.userName
      }
      api.getPaperManagerList(param).then((res) => {
        if (res.status === 200 && res.data.status === 0) {
          this.paperList = res.data.data.content
        }
      })
    },
    getArticleList() {
      if (this.queryName.length === 0) {
        this.$message({
          message: '请输入文章名称',
          type: 'error'
        })
        return
      }
      this.loading = true
      const param = {
        pageNo: this.currentPageNo,
        pageSize: 10,
        baoZhiName: this.baozhiName,
        publishDateStart: this.fromDate || '',
        publishDateEnd: this.toDate || '',
        title: this.queryName
      }
      api.getPaperArticleList(param).then((res) => {
        if (res.status === 200 && res.data.status === 0) {
          this.searchedParam = param
          let data = res.data.data
          this.tableData = data.content.map((item) => {
            return {
              ...item,
              periodical: item.publishDate ? moment(item.publishDate).format('YYYY-MM-DD') : ''
            }
          })
          this.totalCount = data.totalElements
        }
        this.loading = false
      })
    },
    reset() {
      if (this.resetAble) {
        this.queryName = ''
        this.baozhiName = ''
        this.fromDate = ''
        this.toDate = ''
      }
    },
    //翻页
    flipPage(pageNo) {
      this.currentPageNo = pageNo
      this.getArticleList()
    },
    revokeRecord() {
      this.$emit('showRevokeHistory')
    }
  },
  created() {
    this.getManagerList()
  }
}
</script>
<style lang="scss" scoped>
.paper-manage {
  padding-left: 18px;
  /deep/ .common-list {
    padding-top: 0;
    height: auto;
  }
  .paper-list-content {
    .el-input {
      flex: 1;
      width: 200px;
      input {
        height: 100%;
      }
      .el-input__inner {
        font-size: 14px;
        padding: 2px;
      }
    }
    .table-head {
      padding-bottom: 20px;
      .btns {
        margin-top: 20px;
      }
    }
    .head-button {
      margin-right: 10px;
      color: #f0f0f0;
      font-size: 18px;
      line-height: 36px;
      vertical-align: top;
      text-align: center;
      display: inline-flex;
      align-items: center;
      cursor: pointer;
      background-color: rgba(223, 88, 19, 1);
      border-radius: 8px;

      .input_icon {
        width: 22px;
        height: 22px;
        margin-left: 12px;
        display: block;
      }
      span {
        display: block;
        margin: 0 17px;
      }
      &.inactive {
        background-color: #999999;
        cursor: not-allowed;
      }
    }
  }
  .option-button {
    display: inline-block;
    cursor: pointer;
    color: #df5813;
    margin-right: 20px;
  }
  ::v-deep .is-horizontal {
    height: 0px;
    left: 0px;
    display: none;
  }

  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .queryNameInputWrap {
    margin-bottom: 10px;
  }
}
</style>
